import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button, Icon } from 'shared/components';

import theme from './DefaultModal.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  heading: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  bodyValues: PropTypes.shape(),
  buttonMessageId: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

const defaultProps = {
  bodyValues: undefined,
  buttonMessageId: 'const.button.ok',
};

const DefaultModal = ({ intl, heading, body, bodyValues, buttonMessageId, onClick }) => (
  <div className={ theme.root }>
    <div className={ theme.heading }>
      <FormattedMessage id={ heading } />
      <button onClick={ onClick } className={ theme.closingIconContainer }>
        <Icon name="naked-x" />
      </button>
    </div>
    <div className={ theme.body }>
      <FormattedMessage id={ body } values={ bodyValues } />
    </div>
    <div className={ theme.footer }>
      <Button
        testId="default-modal-submit"
        label={ intl.formatMessage({ id: buttonMessageId }) }
        className={ theme.okButton }
        onClick={ onClick }
      />
    </div>
  </div>
);

DefaultModal.propTypes = propTypes;
DefaultModal.defaultProps = defaultProps;

export default DefaultModal;
